import axios from "axios";
import { ElLoading, ElMessage, ElMessageBox } from "element-plus";
import { useBasicStore } from "@/store/auth";
import { langTitle } from "@/hooks/use-common";

//使用axios.create()创建一个axios请求实例
const service = axios.create();
let loadingInstance = null; //loading实例
//请求前拦截
service.interceptors.request.use(
    (req) => {
        const { token, axiosPromiseArr } = useBasicStore();
        //axiosPromiseArr收集请求地址,用于取消请求
        req.cancelToken = new axios.CancelToken((cancel) => {
            axiosPromiseArr.push({
                url: req.url,
                cancel,
            });
        });
        //设置token到header
        req.headers["authorization"] = "Bearer " + token;
        //如果req.method给get 请求参数设置为 ?name=xxx
        if ("get".includes(req.method?.toLowerCase())) req.params = req.data;

        //req loading
        // @ts-ignore
        if (req.reqLoading ?? true) {
            loadingInstance = ElLoading.service({
                lock: true,
                fullscreen: true,
                // spinner: 'CircleCheck',
                text: "loading...",
                background: "rgba(0, 0, 0, 0.3)",
            });
        }

        return req;
    },
    (err) => {
        //发送请求失败
        Promise.reject(err);
    }
);
//请求后拦截
service.interceptors.response.use(
    (res) => {
        if (loadingInstance) {
            loadingInstance && loadingInstance.close();
        }

        //download file
        if (
            ["application/zip", "zip", "blob", "arraybuffer"].includes(
                res.headers["content-type"]
            )
        ) {
            return res;
        }
        // const { code, msg } = res.data;
        const code = res.status;
        const msg = res.data.message;
        const response = res;
        const successCode = "0,200,20000";
        const noAuthCode = "401,403";
        if (successCode.includes(code)) {
            return response;
        } else {
            if (noAuthCode.includes(code)) {
                ElMessageBox.confirm(langTitle("relogin_title"), {
                    confirmButtonText: langTitle("relogin"),
                    closeOnClickModal: false,
                    showCancelButton: false,
                    showClose: false,
                    type: "warning",
                }).then(() => {
                    useBasicStore().resetStateAndToLogin();
                });
            }
            // @ts-ignore
            if (!res.config?.isNotTipErrorMsg) {
                ElMessage.error({
                    message: msg,
                    duration: 2 * 1000,
                });
            }
            return Promise.reject(msg);
        }
    },
    //响应报错
    (err) => {
        // console.log("err", err);
        if (loadingInstance) {
            loadingInstance && loadingInstance.close();
        }
        if (!err.response.length) {
            ElMessage.error({
                message: err.response.data.message,
                duration: 2 * 1000,
            });
        } else {
            ElMessage.error({
                message: err,
                duration: 2 * 1000,
            });
        }
        return Promise.reject(err);
    }
);
//导出service实例给页面调用 , config->页面的配置
export default function axiosReq(config) {
    return service({
        baseURL: "/",
        // baseURL: "https://github.jzfai.top/micro-service-api",
        // baseURL: import.meta.env.VITE_APP_BASE_URL,
        timeout: 8000,
        ...config,
    });
}
